'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _endHashtagMatch = require('./regexp/endHashtagMatch');

var _endHashtagMatch2 = _interopRequireDefault(_endHashtagMatch);

var _extractUrlsWithIndices = require('./extractUrlsWithIndices');

var _extractUrlsWithIndices2 = _interopRequireDefault(_extractUrlsWithIndices);

var _hashSigns = require('./regexp/hashSigns');

var _hashSigns2 = _interopRequireDefault(_hashSigns);

var _removeOverlappingEntities = require('./removeOverlappingEntities');

var _removeOverlappingEntities2 = _interopRequireDefault(_removeOverlappingEntities);

var _validHashtag = require('./regexp/validHashtag');

var _validHashtag2 = _interopRequireDefault(_validHashtag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var extractHashtagsWithIndices = function extractHashtagsWithIndices(text, options) {
  if (!options) {
    options = { checkUrlOverlap: true };
  }

  if (!text || !text.match(_hashSigns2.default)) {
    return [];
  }

  var tags = [];

  text.replace(_validHashtag2.default, function (match, before, hash, hashText, offset, chunk) {
    var after = chunk.slice(offset + match.length);
    if (after.match(_endHashtagMatch2.default)) {
      return;
    }
    var startPosition = offset + before.length;
    var endPosition = startPosition + hashText.length + 1;
    tags.push({
      hashtag: hashText,
      indices: [startPosition, endPosition]
    });
  });

  if (options.checkUrlOverlap) {
    // also extract URL entities
    var urls = (0, _extractUrlsWithIndices2.default)(text);
    if (urls.length > 0) {
      var entities = tags.concat(urls);
      // remove overlap
      (0, _removeOverlappingEntities2.default)(entities);
      // only push back hashtags
      tags = [];
      for (var i = 0; i < entities.length; i++) {
        if (entities[i].hashtag) {
          tags.push(entities[i]);
        }
      }
    }
  }

  return tags;
}; // Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

exports.default = extractHashtagsWithIndices;
module.exports = exports['default'];